module.exports = __webpack_public_path__ + "static/scale-model-of-charm-city-clue-room-in-baltimore-maryland-319cdf7c7b4ddb65356fbaac09692f8e.png";